import { CircularProgress, Stack } from '@mui/material';
import { LoaderProps } from './types';

const Loader = (props: LoaderProps) => {
  const { color, ...progressDefaultProps } = props;

  return (
    <Stack display="flex" justifyContent="center" alignItems="center">
      <CircularProgress {...progressDefaultProps} />
    </Stack>
  );
};

export default Loader;
